// Test IDs for the controllatelefoni.it shop. Keys camelCase, values kebab-case.

export const NAV = {
  navbar: 'site-navbar',
  logo: 'navbar-logo',
  buyNow: 'navbar-buy-now-button',
  themeToggle: 'navbar-theme-toggle',
  themeIcon: 'theme-toggle-icon',
  mobileMenu: 'navbar-mobile-menu-button',
};

export const HERO = {
  section: 'home-hero',
  primary: 'hero-primary-cta',
  secondary: 'hero-secondary-cta',
};

export const FEATURES = {
  section: 'monitoring-features-section',
  tabs: 'features-tabs',
};

export const HOWITWORKS = {
  section: 'how-it-works-section',
};

export const PHONES = {
  section: 'phone-showcase-section',
  card: 'phone-card',
  select: 'phone-select-button',
  brandFilter: 'phone-brand-filter',
};

export const PRICING = {
  section: 'pricing-section',
  card: 'plan-card',
  cta: 'plan-checkout-button',
};

export const TESTIMONIALS = {
  section: 'testimonials-section',
};

export const FAQS = {
  section: 'faq-section',
};

export const CONTACT = {
  section: 'contact-section',
  name: 'contact-name-input',
  email: 'contact-email-input',
  phone: 'contact-phone-input',
  message: 'contact-message-input',
  submit: 'contact-form-submit-button',
};

export const FOOTER = {
  section: 'site-footer',
  adminLink: 'footer-admin-link',
};

export const WHATSAPP = {
  float: 'whatsapp-float-button',
  panel: 'chat-widget-panel',
  input: 'chat-widget-input',
  send: 'chat-widget-send',
  close: 'chat-widget-close',
};

export const BANNER = {
  section: 'live-stats-banner',
  online: 'live-online-count',
  today: 'live-today-count',
};

export const SHOP = {
  page: 'shop-page',
  cta: 'shop-cta-button',
};

export const CHECKOUT = {
  page: 'checkout-page',
  summary: 'checkout-order-summary',
  fullName: 'checkout-fullname-input',
  email: 'checkout-email-input',
  phone: 'checkout-phone-input',
  notes: 'checkout-notes-input',
  consent: 'checkout-consent-checkbox',
  planSelect: 'checkout-plan-select',
  removePhone: 'checkout-remove-phone-button',
  submit: 'checkout-submit-button',
  paypal: 'paypal-pay-button',
  markPaid: 'checkout-mark-paid-button',
  empty: 'checkout-empty-cta',
};

export const SUCCESS = {
  page: 'checkout-success-page',
  home: 'success-home-button',
};

export const ADMIN = {
  page: 'admin-page',
  tokenInput: 'admin-token-input',
  login: 'admin-login-button',
  logout: 'admin-logout-button',
  refresh: 'admin-refresh-button',
  analyticsTab: 'admin-analytics-tab',
  ordersTab: 'admin-orders-tab',
  contactsTab: 'admin-contacts-tab',
  pricesTab: 'admin-prices-tab',
  phonesTab: 'admin-phones-tab',
  settingsTab: 'admin-settings-tab',
  // Orders deletion
  selectAllOrders: 'admin-select-all-orders',
  orderCheckbox: 'admin-order-checkbox',
  deleteOrders: 'admin-delete-orders-button',
  confirmDeleteOrders: 'admin-confirm-delete-orders-button',
  // Dashboard KPI
  kpiOnline: 'admin-kpi-online',
  kpiToday: 'admin-kpi-today',
  kpiSessions: 'admin-kpi-sessions',
  kpiTotal: 'admin-kpi-total',
  // Plans
  savePlan: 'admin-save-plan-button',
  planPrice: 'admin-plan-price-input',
  // Phones
  addPhone: 'admin-add-phone-button',
  savePhone: 'admin-save-phone-button',
  deletePhone: 'admin-delete-phone-button',
  phoneBrand: 'admin-phone-brand-input',
  phoneName: 'admin-phone-name-input',
  phoneImage: 'admin-phone-image-input',
  phonePrice: 'admin-phone-price-input',
  // Settings (Google)
  saveSettings: 'admin-save-settings-button',
  ga4: 'admin-ga4-input',
  googleTag: 'admin-google-tag-input',
  adsId: 'admin-ads-id-input',
  adsLabel: 'admin-ads-label-input',
  adsLabelCheckout: 'admin-ads-label-checkout-input',
};
